import React, { useEffect } from 'react';

function Modal({ open, onClose, title, children, disableClose = false, panelClassName = '' }) {
  useEffect(() => {
    if (!open || disableClose) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose, disableClose]);

  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <button
        type="button"
        aria-label="Fechar modal"
        className="absolute inset-0 bg-slate-900/40 backdrop-blur-[1px]"
        onClick={disableClose ? undefined : onClose}
        disabled={disableClose}
        tabIndex={disableClose ? -1 : 0}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        aria-busy={disableClose ? 'true' : undefined}
        className={`relative w-full max-w-lg surface-card shadow-card-md p-6 ${panelClassName}`}
      >
        {title && (
          <h2 id="modal-title" className="text-lg font-semibold text-content-primary mb-1">
            {title}
          </h2>
        )}
        {children}
      </div>
    </div>
  );
}

export default Modal;
